import { DefaultError, QueryClient, QueryKey, UndefinedInitialDataOptions, UseMutateFunction, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { IPagina } from "../Models/Utils/Pagina/Pagina";
import { AxiosResponse } from "axios";

export default class RequestUtilitario {

    /** pode não ser necessário considerando a configuração 'paramSerializer' pré-existente no axios  */
    static objectToQueryString(objeto:object, namepai:string|null = null) : string {
        const dicionarioObjeto:[string, any][] = Object.entries(objeto);

        return dicionarioObjeto.map(([key, value]) => {
            value = value === undefined ? null : value;
            let nomePropriedade = namepai ?? '';

            if (!Array.isArray(objeto))
                nomePropriedade += `${nomePropriedade.length > 0 ? "." : ""}${key}`;

            if (value !== null && typeof value === 'object' && !(value instanceof Date))
                return RequestUtilitario.objectToQueryString(value as object, nomePropriedade);

            const retorno = encodeURI((value instanceof Date ? value?.toJSON() : value) ?? '');

            if (retorno.length <= 0)
                return undefined;
            
            return  `${nomePropriedade}=${retorno}`;
        }).filter(f => f != null && f != undefined).join("&");
    }
    static objectToFormData(objeto:object, formData?:FormData, namepai?:string) : FormData {
        const dicionarioObjeto:[string, any][] = Object.entries(objeto);
        return dicionarioObjeto.reduce((accumulator, [key, value]) => {
            const nomePropriedade = namepai == undefined || namepai?.trim() == "" ? key : `${namepai}.${key}`;
            value = value == undefined ? null : value;
            
            if (value !== null && typeof value === 'object')
                return RequestUtilitario.objectToFormData(value as object, accumulator, nomePropriedade);
            
            accumulator.append(nomePropriedade, encodeURI(value == null && namepai == undefined ? "" : value));

            return accumulator;
        }, formData ?? new FormData());
    }
    static isPromise (data:any) {
        return !!data && (typeof data === 'object' || typeof data === 'function') && typeof data.then === 'function';
    }
}

export type InferMutationTypeFromFn<K extends (...args: any[]) => Promise<any>, TError = DefaultError> = UseMutationOptions<Awaited<ReturnType<K>>, TError, Parameters<K>>;

export type InferMutationTypeFromAxiosFn
    <
        Fn extends (...args: any[]) => Promise<AxiosResponse<any, any>>,
        TResult = Awaited<ReturnType<Fn>>,
        TError = Fn extends Promise<AxiosResponse<any, infer T>> ? T: any,
        TParams = Parameters<Fn>
    > = UseMutationOptions<TResult, TError, TParams>;

export type InferQueryTypeFromAxiosFn<
    Fn extends (...args: any[]) => Promise<AxiosResponse<any, any>>,
    TResult = Awaited<ReturnType<Fn>>,
    TError = Fn extends Promise<AxiosResponse<any, infer T>> ? T : any,
    TParams = Parameters<Fn>
> = { config: Omit<UseQueryOptions<TResult, TError>, "queryKey" | "queryFn">; params: TParams }; 

export type BasicMutationAxiosType<TDataRequest = unknown, TOptionsAdicionais = unknown, TDataResponse = void, TError = Error, TContext = unknown> = UseMutationOptions<TDataResponse, TError, TDataRequest, TContext> & TOptionsAdicionais & {
    queryKey?:(string | number)[]
};

export type BasicQueryType<TQueryFnData = unknown, TOptionsAdicionais = unknown, TError = DefaultError, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey> = Omit<UndefinedInitialDataOptions<TQueryFnData, TError, TData, TQueryKey>, "queryKey"> & TOptionsAdicionais & {
    queryClient?: QueryClient;
    queryKey?: QueryKey
};

export type MutationBasicaParam<TDataRequest = unknown, TDataResponse = void, TOptionsAdicionais = unknown, TError = Error, TContext = unknown> = Omit<UseMutationOptions<TDataResponse, TError, TDataRequest, TContext>, "mutationFn"> & TOptionsAdicionais & {
    queryKey?:QueryKey
};
export type QueryBasicaParam<TResponse, TResponseSelect = TResponse, TAdicional = unknown, TErro = Error, TQueryKey extends QueryKey = QueryKey> = 
    Omit<UndefinedInitialDataOptions<TResponse, TErro, TResponseSelect, TQueryKey>, "queryKey" | "select" | "queryFn"> 
    & { queryKey?:TQueryKey }
    & TAdicional
;

export type PaginaBasicQueryType<
    TData, 
    TQueryFnData = unknown, 
    TOptionsAdicionais = unknown, 
    TError = DefaultError, 
    TQueryKey extends QueryKey = QueryKey
> = UndefinedInitialDataOptions<TQueryFnData, TError, IPagina<TData>, TQueryKey> & TOptionsAdicionais & {
    pagina:IPagina<TData>
};

var ObjectToQueryString = RequestUtilitario.objectToQueryString;